/**
 * True when size_kb has been set (including 0). False while still processing (null/undefined).
 */
export function hasKnownMediaSizeKb(sizeKb: number | null | undefined): boolean {
    return sizeKb !== null && sizeKb !== undefined;
}

/** Library audio is ready to play or attach (size known and no processing error). */
export function isLibraryAudioReady(file: { sizeKb?: number | null; processingMsg?: string | null }): boolean {
    return hasKnownMediaSizeKb(file.sizeKb) && !file.processingMsg;
}

/** Format stored size in KB for display (2 decimal places under 1 MB). */
export function formatSizeKb(kb: number | null | undefined): string {
    if (!hasKnownMediaSizeKb(kb)) return '';
    const n = Number(kb);
    if (n < 1024) return `${n.toFixed(2)} KB`;
    return `${(n / 1024).toFixed(2)} MB`;
}
